"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _serviceTypes = _interopRequireDefault(require("../utils/serviceTypes"));
var _utils = require("./utils");
var _excluded = ["counties", "cities", "languages"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// a sample serializedScheme
// {
//   keys: ['end_at', 'send_email', 'start_at', 'target_ids', 'target_type', 'time_field', 'time_period', 'type'],
//   prefix: 'export',
//   transformers: {
//     target_ids: (values) => values.map(val => val.id),
//   },
// }

// used in Serializer.buildFilters
// key will be 'places' or 'counties'
function mapLocations(locationsObj, key, locations) {
  var citiesOrCounties = Object.values(locationsObj).reduce(function (acc, currentLocation) {
    if (currentLocation[key]) {
      return _toConsumableArray(acc).concat(currentLocation[key]);
    }
    return acc;
  }, []);
  var matchedCitiesOrCounties = citiesOrCounties.filter(function (location) {
    return locations.includes(location.full_code);
  });
  return matchedCitiesOrCounties.map(function (matchedLocation) {
    return {
      name: matchedLocation.display_name,
      full_code: matchedLocation.full_code,
      state: matchedLocation.state
    };
  });
}
function formatDistance(distance) {
  return distance === 'any' ? null : distance;
}
function formatAddressType(type) {
  return [type, _lodash["default"].get(type, 'value')].includes('ours') ? null : type;
}
var Serializer = /*#__PURE__*/function () {
  function Serializer() {
    _classCallCheck(this, Serializer);
  }
  _createClass(Serializer, null, [{
    key: "build",
    value: function build(obj) {
      // This is expecting obj to have only one key so the array returned is [ [ key, value ] ],
      // we want to destructure the first array
      var _Object$entries$ = _slicedToArray(Object.entries(obj)[0], 2),
        type = _Object$entries$[0],
        rawObject = _Object$entries$[1];

      // The Object constructor creates an object wrapper for the given value.
      // If the value is null or undefined, it will create and return an empty object,
      // otherwise, it will return an object of a type that corresponds to the given value.
      // If the value is an object already, it will return the value.
      // Use this check to short circuit work for null, undefined or primitives
      if (rawObject !== Object(rawObject)) {
        return rawObject;
      }
      var serializedScheme = _utils.SERIALIZER_DICTIONARY[type];

      // there is a defined serializer for the type
      if (serializedScheme) {
        var keys = serializedScheme.keys,
          prefix = serializedScheme.prefix,
          transformers = serializedScheme.transformers;

        // Object.entries returns an array for an object that looks like [[key, value], [key, value], [key, value]]
        return Object.entries(rawObject).reduce(function (acc, _ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          // look for current key in the array of whitelisted keys
          if (keys.includes(key)) {
            // create new key if there is a prefix found
            var prefixedKey = prefix ? "".concat(prefix, "_").concat(key) : key;

            // check to see if there is any transformation needed for the values
            if (transformers && transformers[key]) {
              return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prefixedKey, transformers[key](value)));
            }
            return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prefixedKey, value));
          }
          // return the acc if the key is not found in the array of whitelisted keys
          return acc;
        }, {});
      }

      // no defined serializer for the type, so return the object passed in
      return rawObject;
    }
  }, {
    key: "buildFilters",
    value: function buildFilters(_ref3) {
      var langs = _ref3.langs,
        geography = _ref3.geography,
        network = _ref3.network,
        filters = _ref3.filters,
        services = _ref3.services;
      // pull these out of the rest of the filters for building readable data for tracking
      var counties = filters.counties,
        cities = filters.cities,
        languages = filters.languages,
        rest = _objectWithoutProperties(filters, _excluded);

      // build slim counties matching the county full codes from filters
      var countyObjs = mapLocations(geography, 'counties', counties);

      // build slim cities matching the city full codes from filters
      var cityObjs = mapLocations(geography, 'places', cities);

      // use the display name of the language found from the values in filters
      var languageStrings = langs.reduce(function (acc, currentLanguage) {
        if (languages.includes(currentLanguage.value)) {
          return [].concat(_toConsumableArray(acc), [currentLanguage.display_name]);
        }
        return acc;
      }, []);
      var distance = formatDistance(filters.distance);
      var addressType = formatAddressType(filters.addressType);

      // map filter service type ids to names for readability
      var serviceTypeNames = _serviceTypes["default"].flattenServiceTypes(services).reduce(function (acc, curr) {
        if (filters.serviceTypes.includes(curr.id)) {
          return [].concat(_toConsumableArray(acc), [curr.name]);
        }
        return acc;
      }, []);

      // build the browse filters object used for tracking
      var browseFilters = Serializer.build({
        browseFilters: _objectSpread({}, _lodash["default"].uuCompactArrayOrObject(_objectSpread(_objectSpread({}, rest), {}, {
          addressType: addressType,
          cities: cityObjs,
          counties: countyObjs,
          distance: distance,
          languages: languageStrings,
          serviceTypes: serviceTypeNames
        })))
      });

      // return browse filters along with original browse filters keys array and network info for tracking
      return _objectSpread(_objectSpread({}, browseFilters), {}, {
        browse_filters: (0, _utils.createFilterTrackingObject)(filters),
        browse_network_id: network.id,
        browse_network_name: network.name
      });
    }
  }]);
  return Serializer;
}();
var _default = exports["default"] = Serializer;